<template>
  <span class="w-fit px-3 rounded h-6" :class="['py-0.5', className]">{{ text }}</span>
</template>

<script lang="ts" setup>
defineProps({
  text: {
    type: String,
    required: true,
  },
  className: {
    type: String,
    default: 'text-sm font-medium bg-gray-900 text-white',
  },
})
</script>
